<template>
  <div data-testid="chatbot-menu-item" :class="wrapperClass">
    <v-tooltip
      v-if="mini"
      :data-testid="`${testIdPrefix}__chatbot-tooltip`"
      right
      content-class="tooltip-right"
    >
      <template #activator="{ on, attrs }">
        <v-list-item
          v-if="useDrawer"
          :data-testid="`${testIdPrefix}__chatbot-button`"
          v-bind="attrs"
          v-on="on"
          :class="listItemClass"
          :aria-label="ariaLabel"
          @click.stop.prevent="handleClick"
        >
          <img
            :data-testid="`${testIdPrefix}__chatbot-icon`"
            :src="iconSrc"
            :alt="iconAlt"
            class="nav-img-icon"
          />
        </v-list-item>
        <v-list-item
          v-else
          :data-testid="`${testIdPrefix}__chatbot-link`"
          v-bind="attrs"
          v-on="on"
          :class="listItemClass"
          :aria-label="ariaLabel"
          :to="linkTarget"
          link
        >
          <img
            :data-testid="`${testIdPrefix}__chatbot-icon`"
            :src="iconSrc"
            :alt="iconAlt"
            class="nav-img-icon"
          />
        </v-list-item>
      </template>
      <span :data-testid="`${testIdPrefix}__chatbot-tooltip-text`">{{ label }}</span>
    </v-tooltip>

    <template v-else>
      <v-list-item
        v-if="useDrawer"
        :data-testid="`${testIdPrefix}__chatbot-button`"
        :class="listItemClass"
        :aria-label="ariaLabel"
        @click.stop.prevent="handleClick"
      >
        <img
          :data-testid="`${testIdPrefix}__chatbot-icon`"
          :src="iconSrc"
          :alt="iconAlt"
          class="nav-img-icon"
        />
        <v-list-item-content
          :data-testid="`${testIdPrefix}__chatbot-content`"
          class="pa-0 d-flex align-center"
        >
          <component
            :is="labelTag"
            :data-testid="`${testIdPrefix}__chatbot-text`"
            :class="labelClass"
          >
            {{ label }}
          </component>
        </v-list-item-content>
      </v-list-item>

      <v-list-item
        v-else
        :data-testid="`${testIdPrefix}__chatbot-link`"
        :class="listItemClass"
        :aria-label="ariaLabel"
        :to="linkTarget"
        link
      >
        <img
          :data-testid="`${testIdPrefix}__chatbot-icon`"
          :src="iconSrc"
          :alt="iconAlt"
          class="nav-img-icon"
        />
        <v-list-item-content
          :data-testid="`${testIdPrefix}__chatbot-content`"
          class="pa-0 d-flex align-center"
        >
          <component
            :is="labelTag"
            :data-testid="`${testIdPrefix}__chatbot-text`"
            :class="labelClass"
          >
            {{ label }}
          </component>
        </v-list-item-content>
      </v-list-item>
    </template>
  </div>
</template>

<script>
import globalConstants from '../../plugins/constants';

const ASK_NOA_LABEL = globalConstants.ASK_NOA_LABEL;

export default {
  name: 'ChatbotMenuItem',
  props: {
    mini: {
      type: Boolean,
      default: false
    },
    useDrawer: {
      type: Boolean,
      default: true
    },
    label: {
      type: String,
      default: ASK_NOA_LABEL
    },
    iconSrc: {
      type: String,
      default: '/img/icons/agentic/ark-agent-icon.svg'
    },
    iconAlt: {
      type: String,
      default: `${ASK_NOA_LABEL} icon`
    },
    chatbotRoute: {
      type: [String, Object],
      default: '/chatbot/home'
    },
    testIdPrefix: {
      type: String,
      default: 'chatbot-menu'
    },
    extraClasses: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    activeClass: {
      type: String,
      default: 'radius-small selected-menu-item'
    },
    ariaLabel: {
      type: String,
      default: ASK_NOA_LABEL
    },
    labelTag: {
      type: String,
      default: 'v-list-item-title'
    },
    labelClass: {
      type: String,
      default: 'side-nav-text-color hide-when-mini text-truncate'
    },
    wrapperClass: {
      type: String,
      default: ''
    }
  },
  computed: {
    listItemClass() {
      const classes = [
        'nav-standard-item',
        'd-flex',
        'align-center',
        'cursor-pointer',
        this.extraClasses
      ];
      if (this.active) {
        classes.push(this.activeClass);
      }
      return classes.join(' ').replace(/\s+/g, ' ').trim();
    },
    linkTarget() {
      if (typeof this.chatbotRoute === 'object') return this.chatbotRoute;
      const go = this.$nova?.gotoLink;
      if (typeof go === 'function') {
        return go({ path: this.chatbotRoute }, true);
      }
      return { path: this.chatbotRoute };
    }
  },
  methods: {
    handleClick() {
      this.$emit('click');
    }
  }
};
</script>
